import { render, staticRenderFns } from "./TeacherMaterials.vue?vue&type=template&id=f86715c0&scoped=true&"
import script from "./TeacherMaterials.vue?vue&type=script&lang=js&"
export * from "./TeacherMaterials.vue?vue&type=script&lang=js&"
import style0 from "./TeacherMaterials.vue?vue&type=style&index=0&id=f86715c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86715c0",
  null
  
)

export default component.exports